export const API_GATEWAY_ALLOWED_LIST = 'GET_API_GATEWAY_ALLOWED_LIST';
export const API_GATEWAY_ALLOWED_LIST_REQUEST =
  'API_GATEWAY_ALLOWED_LIST_REQUEST';
export const API_GATEWAY_ALLOWED_LIST_SUCCESS =
  'GET_API_GATEWAY_ALLOWED_LIST_SUCCESS';
export const API_GATEWAY_ALLOWED_LIST_FAILURE =
  'API_GATEWAY_ALLOWED_LIST_FAILURE';

export type API_GATEWAY_ALLOWED_LIST = typeof API_GATEWAY_ALLOWED_LIST;

export type API_GATEWAY_ALLOWED_LIST_REQUEST =
  typeof API_GATEWAY_ALLOWED_LIST_REQUEST;

export type API_GATEWAY_ALLOWED_LIST_SUCCESS =
  typeof API_GATEWAY_ALLOWED_LIST_SUCCESS;

export type API_GATEWAY_ALLOWED_LIST_FAILURE =
  typeof API_GATEWAY_ALLOWED_LIST_FAILURE;
